import React from 'react';

import { ListItemIcon, MenuItem } from '@material-ui/core';

import Menu from '~/components/Menu';
import { useAuth } from '~/hooks/auth';

import { TableMenuProps } from '../interface';

function TableMenu<Entity>({ entity, menus }: TableMenuProps<Entity>) {
  const { checkPermission } = useAuth();

  return (
    <Menu>
      {menus.map(
        (menu) =>
          checkPermission(menu.permissions) &&
          (!menu.condition || menu.condition(entity)) && (
            <MenuItem
              disabled={menu.disabled}
              onClick={() => menu.action(entity)}
            >
              <ListItemIcon>
                <menu.Icon size={16} />
                {menu.label}
              </ListItemIcon>
            </MenuItem>
          ),
      )}
    </Menu>
  );
}

export default TableMenu;
